import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import Home from "./routes/Home";
import NewCards from "./routes/NewCards";
import Login from "./routes/Login";
import Collection from "./routes/Collection";
import Scene from "./routes/Scene";
import Header from "../common/Header";
import { useAuth } from "../context/AuthContext";
import { ScenesProvider } from "../context/ScenesContext";

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { credential } = useAuth();
  if (!credential) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <ScenesProvider>
                <div className="app-shell">
                  <Header />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/new" element={<NewCards />} />
                    <Route path="/collection/:collectionId" element={<Collection />} />
                    <Route path="/collection/:collectionId/:sceneId" element={<Scene />} />
                  </Routes>
                </div>
              </ScenesProvider>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

